/* global GOOGLE_KEY: false */
import React, {
  PropTypes as T,
  Component,
} from 'react';
import radium, { StyleRoot } from 'radium';
import { Link as link } from 'react-router';
import logoImage from '../../static/images/logo.png';
import Footer from '../Footer.js';

const Link = radium(link);

const styles = {
  wrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    height: '100%',
    padding: '0 0 60px 0',
    minHeight: 530,
  },
  header: {
    height: 90,
    width: '100%',
    boxShadow: '0 3px 0 0 #fed312',
    padding: '0 24px',
    lineHeight: '90px',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    minHeight: 90,
    '@media (max-width: 767px)': {
      flexWrap: 'wrap',
    },
  },
  logo: {
    width: 150,
    display: 'block',
  },
  logoWrap: {
    width: 208,
    display: 'flex',
    justifyContent: 'center',
  },
  title: {
    fontSize: 16,
    color: '#004d9f',
    letterSpacing: 4,
    opacity: 0.4,
    fontWeight: 300,
    margin: '0 0 0 44px',
    '@media (max-width: 767px)': {
      lineHeight: '20px',
      display: 'block',
      width: '100%',
    },
  },
  mainField: {
    flex: 1,
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    backgroundColor: '#FBFBF6',
  },
  main: {
    flex: 1,
    maxHeight: 'calc(100vh - 150px)',
    overflow: 'auto',
    '@media (max-width: 767px)': {
      overflow: 'hidden',
    },
  },
};

class Reservations extends Component {
  componentWillMount() {
    console.log(GOOGLE_KEY);
    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_KEY}&callback=initMap`;
    document.body.appendChild(script);
  }

  findTitle(routes) {
    const hasTitleRoute = routes.reverse().find((route) => !!route.title);

    if (hasTitleRoute) {
      return hasTitleRoute.title;
    }

    return '';
  }

  render() {
    const {
      routes,
      children,
    } = this.props;

    return (
      <StyleRoot style={styles.wrapper}>
        <header style={styles.header}>
          <Link to="/" style={styles.logoWrap}>
            <img alt="logo" src={logoImage} style={styles.logo} />
          </Link>
          <h1 style={styles.title}>{this.findTitle(routes)}</h1>
        </header>
        <div style={styles.mainField}>
          <main style={styles.main}>
            {children}
          </main>
        </div>
        <Footer />
      </StyleRoot>
    );
  }
}

Reservations.propTypes = {
  children: T.node,
  routes: T.array,
};

export default Reservations;



// WEBPACK FOOTER //
// ./components/Reservations/ReservationBoard.js